import ViewDayOutlinedIcon from "@mui/icons-material/ViewDayOutlined";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { changeDayNoCache, changeWeekNoCache,switchCalendarView } from "../../store/scheduler-slice";

const SwitchViews = ({ isWeekView = true }: { isWeekView: boolean }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentDate = useSelector(
    (state: any) => state.supervisor?.schedulerData?.currentDate
  );

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newView: string | null
  ) => {
    if (newView === null) return; // Prevent deselecting
    const switchingToWeek = newView === "week";
    dispatch(switchCalendarView(switchingToWeek));
    // Re-fetch data for the correct date when switching views
    const date = currentDate ? new Date(currentDate) : new Date();
    if (switchingToWeek) {
      dispatch(changeWeekNoCache(date));
    } else {
      dispatch(changeDayNoCache(date));
    }
  };

  const currentView = isWeekView ? "week" : "day";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Typography
        sx={{
          fontFamily: "Roboto",
          fontSize: "12px",
          fontWeight: 500,
          color: "rgba(0,0,0,0.4)",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          lineHeight: 1,
        }}
      >
        {t("scheduler_view")}
      </Typography>
      <ToggleButtonGroup
        value={currentView}
        exclusive
        onChange={handleChange}
        aria-label={t("scheduler_calendar-view")}
        size="small"
        sx={{
          height: "36px",
          "& .MuiToggleButtonGroup-grouped": {
            border: "1px solid rgba(0,0,0,0.12)",
            "&:not(:first-of-type)": {
              borderLeft: "1px solid rgba(0,0,0,0.12)",
              marginLeft: 0,
            },
          },
          "& .MuiToggleButton-root": {
            textTransform: "none",
            fontFamily: "Roboto",
            fontSize: "13px",
            fontWeight: 500,
            letterSpacing: "0.4px",
            color: "rgba(0,0,0,0.6)",
            padding: "6px 12px",
            gap: "6px",
            minWidth: "80px",
            "&.Mui-selected": {
              backgroundColor: "primary.main",
              color: "#fff",
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            },
          },
        }}
      >
        <ToggleButton value="day" aria-label={t("scheduler_day-view")}>
          <ViewDayOutlinedIcon sx={{ fontSize: "18px" }} />
          {t("scheduler_day")}
        </ToggleButton>
        <ToggleButton value="week" aria-label={t("scheduler_week-view")}>
          <ViewWeekOutlinedIcon sx={{ fontSize: "18px" }} />
          {t("scheduler_week")}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SwitchViews;
